import { render, staticRenderFns } from "./BaseTeacherPicker.vue?vue&type=template&id=2e255d8c&"
import script from "./BaseTeacherPicker.vue?vue&type=script&lang=js&"
export * from "./BaseTeacherPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e255d8c')) {
      api.createRecord('2e255d8c', component.options)
    } else {
      api.reload('2e255d8c', component.options)
    }
    module.hot.accept("./BaseTeacherPicker.vue?vue&type=template&id=2e255d8c&", function () {
      api.rerender('2e255d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseTeacherPicker.vue"
export default component.exports